import { FunctionComponent, ReactNode, useEffect, useLayoutEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import styles from './DictationWidget.module.scss'

const VIEWPORT_MARGIN = 8

type Props = {
  children: ReactNode
  onClose: () => void
  align?: 'left' | 'right'
  direction?: 'down' | 'up'
}

export const WidgetPopover: FunctionComponent<Props> = ({
  children,
  onClose,
  align = 'left',
  direction = 'down',
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [resolvedDirection, setResolvedDirection] = useState(direction)

  // Widget proche d'un bord : on ouvre de l'autre côté plutôt que de couper les choix.
  useLayoutEffect(() => {
    const rect = ref.current?.getBoundingClientRect()
    if (!rect) return
    if (direction === 'up' && rect.top < VIEWPORT_MARGIN) setResolvedDirection('down')
    else if (direction === 'down' && rect.bottom > window.innerHeight - VIEWPORT_MARGIN)
      setResolvedDirection('up')
    else setResolvedDirection(direction)
  }, [direction])

  useEffect(() => {
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose()
    }
    document.addEventListener('mousedown', onDown)
    return () => document.removeEventListener('mousedown', onDown)
  }, [onClose])

  return (
    <div
      ref={ref}
      className={classNames(
        styles.pop,
        align === 'right' ? styles.popRight : styles.popLeft,
        resolvedDirection === 'up' ? styles.popUp : styles.popDown,
      )}
    >
      {children}
    </div>
  )
}
